import { render, staticRenderFns } from "./employer_declaration_yukon.vue?vue&type=template&id=2f810dc1&"
import script from "./employer_declaration_yukon.vue?vue&type=script&lang=js&"
export * from "./employer_declaration_yukon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports